// removed by extract-text-webpack-plugin
module.exports = {"base":"NoVehicles_base--37dBn"};


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/containers/PlayersMatchingView/components/NoVehicles/NoVehicles.scss
// module id = 468
// module chunks = 11 12